module.exports = __webpack_public_path__ + "img/stars-in-night-sky.bec0731d.jpg";